import { RESIDUAL_DEBT_INSURANCES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { InsuranceCard } from './InsuranceCard';

const INSURANCE_ORDER = [
    RESIDUAL_DEBT_INSURANCES.DEATH,
    RESIDUAL_DEBT_INSURANCES.WORK_INCAPACITY,
    RESIDUAL_DEBT_INSURANCES.UNEMPLOYMENT,
];

type Props = {
    isSecondApplicant: boolean;
};

export const ApplicantInsurances: React.FC<Props> = ({ isSecondApplicant }) => {
    const { t } = useTranslation();
    const applicant = isSecondApplicant ? 'applicant2' : 'applicant1';

    return (
        <div className="flex flex-col gap-2" data-testid={`residual-debt-insurance-${applicant}`}>
            <p className="text-sm font-bold text-midnight">
                {t(
                    `BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.APPLICANT_TITLES.${
                        isSecondApplicant ? 'SECOND_APPLICANT' : 'FIRST_APPLICANT'
                    }`,
                )}
            </p>
            <div className="grid gap-3 xl:grid-cols-3">
                {INSURANCE_ORDER.map((insurance) => (
                    <InsuranceCard key={insurance} applicant={applicant} insurance={insurance} />
                ))}
            </div>
        </div>
    );
};
